import type { ReactElement } from 'react';

import dynamic from 'next/dynamic';

import type { ContentSection as ContentSectionSchema } from '~/amplienceTypes/schemas/exported/section-schema';

const SectionHero = dynamic(
  async () => (await import('../components/sections/SectionHero')).SectionHero
);

const SectionText = dynamic(
  async () => (await import('../components/sections/SectionText')).SectionText
);

const SectionProductInfo = dynamic(
  async () => (await import('../components/sections/SectionProductInfo')).SectionProductInfo
);

const SectionTiles = dynamic(
  async () => (await import('../components/sections/SectionTiles')).SectionTiles
);

type Props = ContentSectionSchema;

const getSection = (props: Props): ReactElement => {
  const { layout } = props;

  switch (true) {
    case layout === 'Collection [Hero]':
      return <SectionHero content={props} />;
    case layout === 'Collection Tiles [Text, Carousel]':
      return <SectionTiles content={props} />;
    case layout === 'Collection Editorial [Text, Carousel | Mood Image | Key Image]':
      return <SectionText content={props} />;
    case layout === 'Collection PDP Product Info':
      return <SectionProductInfo content={props} />;
    default:
      return <></>;
  }
};

export const CollectionSectionTemplate = (props: Props): ReactElement => getSection(props);
